import {Stack} from "@src/CommonComponents/Stack/Stack.tsx";
import styles from "./statusBanner.module.less"
import {WifiOff} from "@UI/components/icons/WifiOff.tsx";
import {Gt} from "@src/i18n/Gt.tsx";
import {Body_14_Coral_Strong_emphasis_14} from "@UI/typography/generated/typography.tsx";
import {useNetworkWatcher} from "@src/utils/net.ts";
import cn from "classnames";
import {CloudProcess} from "@UI/components/icons/CloudProcess.tsx";
import {CloudSuccess} from "@UI/components/icons/CloudSuccess.tsx";
import {CloudFail} from "@UI/components/icons/CloudFail.tsx";
import {sleep, SyncStatus, Timeouts, useSyncStore} from "@src/offline/sync.ts";
import {useEffect, useState} from "react";
import {Button, ButtonType} from "@UI/components/controls/Button/Button.tsx";
import {ColorNames} from "@UI/theme/generated/ColorNames.ts";


export const StatusBanner = () => {
    const {online} = useNetworkWatcher();
    const syncStatus = useSyncStore(x => x.syncStatus);
    const syncRetry = useSyncStore(x => x.retry);
    const [showBanner, setShowBanner] = useState<boolean>(false);

    useEffect(() => {
        if (!online) {
            setShowBanner(true);
            sleep(Timeouts.Default).then(() => setShowBanner(false));
        }
    }, [online]);

    if (!online && showBanner)
        return (
            <Stack className={cn(styles.root, styles.offline)} alignItems={"center"} justifyContent={"center"}>
                <WifiOff/>
                <Body_14_Coral_Strong_emphasis_14>
                    <Gt>No internet connection</Gt>
                </Body_14_Coral_Strong_emphasis_14>
            </Stack>
        )

    else if (syncStatus == SyncStatus.Processing)
        return (
            <Stack className={cn(styles.root, styles.sync)} alignItems={"center"} justifyContent={"center"}>
                <CloudProcess/>
                <Body_14_Coral_Strong_emphasis_14>
                    <Gt>Syncing data...</Gt>
                </Body_14_Coral_Strong_emphasis_14>
            </Stack>
        )

    else if (syncStatus == SyncStatus.Success)
        return (
            <Stack className={cn(styles.root, styles.synced)} alignItems={"center"} justifyContent={"center"}>
                <CloudSuccess/>
                <Body_14_Coral_Strong_emphasis_14>
                    <Gt>Syncing completed</Gt>
                </Body_14_Coral_Strong_emphasis_14>
            </Stack>
        )

    else if (syncStatus == SyncStatus.Failure)
        return (
            <Stack className={cn(styles.root, styles.syncFail)} alignItems={"center"} justifyContent={"center"}
                   gap={24}>
                <Stack>
                    <CloudFail/>
                    <Body_14_Coral_Strong_emphasis_14>
                        <Gt>Sync failed</Gt>
                    </Body_14_Coral_Strong_emphasis_14>
                </Stack>

                <Button type={ButtonType.third}
                        minWidth={52}
                        color={ColorNames.OBSIDIAN_LIGHT}
                        onClick={() => syncRetry()}
                        className={styles.retryButton}>
                    <Gt>Retry</Gt>
                </Button>
            </Stack>
        )
}